import {ValueProvider} from "@angular/core"
import {MAT_DATE_FORMATS, MatDateFormats} from "@angular/material"

const format = "DD-MM-YYYY"

const Formats: MatDateFormats = {
    parse: {
        dateInput: format
    },
    display: {
        dateInput: format,
        dateA11yLabel: format,
        monthYearA11yLabel: "YYYY",
        monthYearLabel: "MMM"
    }
}

export const DatePickerFormatProvider: ValueProvider = {
    provide: MAT_DATE_FORMATS,
    useValue: Formats
}
